import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Translation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { shipmentStatusBefore } from '../mappings';
function getGenerateBolOverlay() {
    return (React.createElement(Popover, { id: "generate-bol-popover" },
        React.createElement(Translation, null, (t, { i18n }) => React.createElement("p", null, t('GENERATE_BOL_FAILURE_FOR_SHIPMENT_ACCEPTED')))));
}
class GenerateBol extends Component {
    renderGenerateBolButton(canGenerateBol) {
        const { t } = this.props;
        return (React.createElement("span", { className: "cancel-btn-wrapper" },
            React.createElement(Button, { bsStyle: "success", onClick: this.props.onGenerateBol, disabled: !canGenerateBol }, t('GENERATE_BOL'))));
    }
    render() {
        const canGenerateBol = this.props.isShipper && shipmentStatusBefore(this.props.current_status, 'accepted');
        return (React.createElement("section", null,
            !canGenerateBol && (React.createElement(OverlayTrigger, { placement: "right", trigger: ['hover', 'focus'], overlay: getGenerateBolOverlay() }, this.renderGenerateBolButton(canGenerateBol))),
            canGenerateBol && this.renderGenerateBolButton(canGenerateBol)));
    }
}
GenerateBol.propTypes = {
    current_status: PropTypes.string.isRequired,
    isShipper: PropTypes.bool.isRequired,
    onGenerateBol: PropTypes.func.isRequired,
};
export default withTranslation()(GenerateBol);
